module.exports = __webpack_public_path__ + "static/img/empty-reward.ec938ba7.png";